import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Typography } from '@mui/material';
import { MagicSvgContext } from '../../context/MagicSvgContext/MagicSvgContext';
import MagicSvgShare from './magic-svg-share';
import { ShareButtonsContainer } from './magic-svg.styles';
import { STATUS } from '../../context/MagicSvgContext/magicSvgReducer';
import { USER_ACTIONS, IMAGE_STATUS } from './constants';

const MagicSvgAnimation = dynamic(() => import('./magic-svg-animation'), {
  ssr: false,
});

function MagicSvgGeneratedImage({ isMobile, currentView, hideDownload }) {
  const {
    image,
    generationStatus,
  } = useContext(MagicSvgContext);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (generationStatus === STATUS.SUCCESS && image.svgUrl) {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');

      const img = new Image();
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
      };
      img.src = image.svgUrl;
    }
  }, [generationStatus, image.svgUrl]);

  if (generationStatus === STATUS.LOADING) {
    // this is how lottie react recommends doing this
    return <MagicSvgAnimation animationKey={generationStatus} />;
  }

  if (generationStatus === STATUS.FAILED) {
    return (
      <>
        <MagicSvgAnimation animationKey={generationStatus} />
        <Typography sx={{ textAlign: 'center', margin: '16px' }}>
          {`Oops, please try again. We've refunded your Craft Coins`}
        </Typography>
      </>
    );
  }

  return (
    <>
      {!isMobile
        && (currentView === USER_ACTIONS.REGENERATE || image.status === IMAGE_STATUS.DELIVERED)
        && (
          <ShareButtonsContainer>
            <MagicSvgShare isMobile={isMobile} image={image} hideDownload={hideDownload} />
          </ShareButtonsContainer>
        )}
      <canvas ref={canvasRef} style={{ width: '100%' }} />
    </>
  );
}

MagicSvgGeneratedImage.propTypes = {
  currentView: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  hideDownload: PropTypes.bool.isRequired,
};

export default MagicSvgGeneratedImage;
